import request from '@/utils/request'

// ——— 认证 ———
export const authApi = {
  register: (data: { email: string; password: string; nickname: string; inviteCode: string }) =>
    request.post('/auth/register', data),
  login: (data: { email: string; password: string }) => request.post('/auth/login', data),
  logout: () => request.post('/auth/logout'),
  me: () => request.get('/auth/me'),
}

// ——— 路由 ———
export const routesApi = {
  getRoutes: () => request.get('/routes'),
}

// ——— 首页 ———
export const homeApi = {
  getHealth: () => request.get('/health'),
  getAnnouncements: () => request.get('/announcements'),
}

// ——— 文章 ———
export const articlesApi = {
  getList: () => request.get('/articles'),
  getDetail: (noteId: string) => request.get(`/articles/${noteId}`),
}

// ——— 访问统计上报 ———
export const visitApi = {
  report: (path: string) => request.post('/visit', { path }).catch(() => null), // 静默失败
}

// ——— 用户 ———
export const userApi = {
  getProfile: () => request.get('/user/profile'),
  updateProfile: (data: { nickname?: string; avatar?: string }) =>
    request.put('/user/profile', data),
  changePassword: (data: { oldPassword: string; newPassword: string }) =>
    request.post('/user/change-password', data),
  getMyVisits: () => request.get('/visit/my'),
}
